function formatDate(date) {
    const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    }

    if (typeof date === 'string') {
        date = new Date(Date.parse(date))
    }

    return new Intl.DateTimeFormat('default', options).format(date)
}

export function serializeParamsWithoutBrackets(params) {
    let serializedParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value instanceof Array) {
            value.forEach(singleVal => {
                serializedParams.append(key, singleVal)
            })
        } else {
            serializedParams.append(key, value)
        }
    })
    return serializedParams.toString()
}

/**
 * Adds an axios request interceptor to replace a noCache param with noCache headers.
 * @param client
 * @returns {*}
 */
export function addNoCacheParam(client) {
    client.interceptors.request.use(function addNoCacheInterceptor(config) {
        if (!config.params?.noCache) {
            return config
        }

        config.headers['Cache-Control'] = 'no-cache'
        config.headers['Pragma'] = 'no-cache'
        config.headers['Expires'] = '0'

        delete config.params.noCache

        return config
    })

    return client
}

export default formatDate
